import * as React from "react";
import { forwardRef } from "react";
const SvgIcChevronBackNegative24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 4V20L20 22H4L2 20V4L4 2H20L22 4ZM6 11V12.4141L11 17.4141L12.4141 16L9.12109 12.707H15.707V16.457H17.707V11.707L16.707 10.707H9.12109L12.4141 7.41406L11 6L6 11Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcChevronBackNegative24);
export { ForwardRef as ReactComponent };
